import React from 'react';
import styles from './index.module.scss';
import ArticleFreeContentBlock from './article_free_content_block';
import AuthorAvatars from '../../../other_components/author_avatars';
import { useAuthorAvatarsFromPublication } from '../../../../../hooks/useAuthorAvatarsFromPublication';
import { isCardPublicationBlock, normalizePublicationBlock } from '../../../../../utils/findCardBlock';

const ArticleFreePage = ({ contentData, path_to_folder, template, publication }) => {
  const authorAvatars = useAuthorAvatarsFromPublication(publication);

  if (!contentData || !Array.isArray(contentData) || !path_to_folder) {
    return null;
  }

  const blocksToRender = contentData
    .map((block, index) => ({ block: normalizePublicationBlock(block), index }))
    .filter(({ block, index }) => !isCardPublicationBlock(block, index, template))
    .map(({ block, index }) => {
      const panels = block?.block_content;
      if (!Array.isArray(panels) || panels.length === 0) return null;

      return (
        <div key={`article-free-block-${index}`} className={styles.blockWrapper}>
          <ArticleFreeContentBlock blockData={block} path_to_folder={path_to_folder} />
        </div>
      );
    })
    .filter(Boolean);

  if (blocksToRender.length === 0) {
    return null;
  }

  return (
    <article className={styles.articleFreePage}>
      <div className={styles.blocksContainer}>
        {authorAvatars.length > 0 && (
          <div className={styles.pageAuthorsWrap}>
            <AuthorAvatars authors={authorAvatars} variant='light' placement='pageHeader' />
          </div>
        )}
        {blocksToRender}
      </div>
    </article>
  );
};

export default ArticleFreePage;
